import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import intl from 'react-intl-universal';
import { Popup, Button } from 'antd-mobile';
import { DeleteOutline } from 'antd-mobile-icons';
import './index.less';
import CurrencySymbol from '../../../../components/CurrencySymbol';
import NumStepper from '../../../../components/NumStepper';
import CartIcon from '../../../../components/Icon/CartIcon';
import AttrString from '../../../../components/ProductMenu/AttrString';
import PriceText from '../../../../components/ProductMenu/PriceText';
import ProductOriPrice from '../../../../components/ProductOriPrice';
import { judgeOrderModel } from '../../../../model/store'
import { getMemberInfo } from '../../../../utils/storage/store'
import math, { formatNumber } from '../../../../utils/math';
import { formatJSON } from '../../../../utils';
import { getProductLineAmount, shouldShowPackageDiscount } from '../../../../utils/price';
import { addBehaviorsRecord } from '../../../../utils/BehaviorstatsHelp'
import { setProductBookingRule } from '../../../../store/reducers/hotel'


const ShoppingCart = ({ items = [], onAdd, onRemove, nextAction, storeInfo, hideOrderBtn = false, clearCart }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch()

  const { areaId, storeId, lang, timezoneOffset } = storeInfo
  const { memberId = '' } = getMemberInfo() || {}

  const totalQuantity = items.reduce((sum, item) => math.add(sum, item.quantity || 1), 0);
  const totalPrice = items.reduce((sum, item) => math.add(sum, item.amount), 0);

  const currencyCode = items[0]?.currency || '';

  const popupCart = (isExpanded) => {
    if (items.length === 0) return
    setIsExpanded(isExpanded);
  }

  useEffect(() => {
    return () => {
      setIsExpanded(false)
    }
  }, [])

  const getProductAmount = (item) => getProductLineAmount(item) || 0

  const getProductList = () => {
    return items.map(item => {
      const { productId, productName, price, packagePrice, orgPrice, quantity, images, currency, attrArr, specItem } = item
      const totalPrice = getProductAmount(item) || 0
      //是否有分组情况
      const hasGroupKey = item.attrs?.some(attr => attr.groupKey)
      return {
        amount: quantity || 1,
        isPackage: false,
        productId,
        productName,
        productTypeName: '',
        productExtraNameKey: specItem ? specItem.productExtraNameKey : '',
        productExtraAttrSubKeyValues: attrArr?.map(attr => {
          return {
            key: attr.productExtraAttrSubKey,
            name: attr.productExtraAttrSubName,
            num: attr.quantity || 1,
            parentKey: hasGroupKey ? attr.productExtraAttrKey : '',
            groupKey: attr.groupKey,
          }
        }),
        price,
        packagePrice,
        orgPrice: shouldShowPackageDiscount(item) ? price : orgPrice,
        images,
        currency,
        attrArr,
        specItem,
        productAmount: totalPrice || 0,
        productType: item.productType
      }
    })

  }

  const previewProducts = () => {

    dispatch(setProductBookingRule(null));

    const products = getProductList()
    const totalPrice = products.reduce((acc, item) => math.add(acc, math.mul(item.productAmount || 0, item.amount || 1)), 0)
    const param = {
      areaId,
      memberId,
      lang,
      products,
      storeId,
      timezoneOffset,
      lat: '',
      lng: '',
      remark: '',
      totalPrice,
      checkBookingTime: false
    }

    setLoading(true)
    judgeOrderModel(param, storeInfo?.thirdPartyPreviewCalculate === true ? { isPreview: false } : undefined).then(res => {
      console.log('res', res)
      setLoading(false)

      // get product booking rule when it has booking rule
      if (items && items.length > 0) {
        // 提取计算提前预订总时间的辅助函数
        const calculateAdvanceTime = (extData) => {
          const days = extData?.endAdvanceDay || 0;
          const hours = extData?.endAdvanceHour || 0;
          const minutes = extData?.endAdvanceMinute || 0;
          return Number(days) * 24 + Number(hours) + Number(minutes) / 60;
        };

        // 过滤并映射符合条件的商品
        const ruleArr = items
          .map(pd => ({ pd, extData: formatJSON(pd.extendColumn) }))
          .filter(({ extData }) => {
            const advanceTime = calculateAdvanceTime(extData);
            return extData && !extData.bookingTimeWithStore && advanceTime > 0;
          })
          .map(({ pd, extData }) => ({ ...pd, productRule: extData }));

        // 找出提前预订时间最长的商品
        const maxRuleItem = ruleArr.length > 0
          ? ruleArr.reduce((max, current) => {
            const maxTime = calculateAdvanceTime(max.productRule);
            const currentTime = calculateAdvanceTime(current.productRule);
            return currentTime > maxTime ? current : max;
          })
          : null;

        if (maxRuleItem) {
          dispatch(setProductBookingRule(maxRuleItem));
        }

      }

      nextAction && nextAction()
    }).catch(err => {
      console.log('err', err)
      setLoading(false)
    })


  }

  return (
    <div className="shopping-cart">
      <div className='jm-flex'>
        <div className="cart-price-zone jm-flex-item" onClick={() => popupCart(!isExpanded)}>
          <span className="cart-icon">
            <CartIcon color="var(--adm-color-primary)" width={28} height={28} />
            {totalQuantity > 0 && (<span className="cart-badge">{totalQuantity}</span>)}
          </span>
          <span className="cart-price"><CurrencySymbol currency={currencyCode} />{formatNumber(totalPrice)}</span>
        </div>
        <div className={`cart-button ${hideOrderBtn ? 'hide' : ''}`}>
          <Button
            color='primary'
            size='small'
            style={{ padding: '6px 12px' }}
            loading={loading}
            onClick={() => {
              if (items.length === 0) {
                return
              }
              previewProducts()

              addBehaviorsRecord({
                behaviorType: 160200,
                behavior: 160216,
                storeId: storeId,
                value1: 'spa页'
              })
            }}>{intl.get('confirmOrdering').d('Place Order')}
          </Button>
        </div>
      </div>


      <Popup
        visible={isExpanded && items.length > 0}
        onClose={() => setIsExpanded(false)}
        onMaskClick={() => setIsExpanded(false)}
        // showCloseButton
        destroyOnClose
      >
        {isExpanded && items.length > 0 && (
          <div className='cart-popup'>
            <div className="cart-panel">
              <div className='cart-title jm-flex'>
                <div className='jm-flex-item'>
                  {intl.get('cart').d('购物车')}
                </div>
                <div>
                  <div
                    className='btn-clear-cart'
                    onClick={() => {
                      clearCart()
                      setIsExpanded(false)
                    }}>
                    <DeleteOutline fontSize={16} />&nbsp;
                    {intl.get('clear_all').d('清空全部')}
                  </div>
                </div>
              </div>
              <div className='cart-item-list'>
                {items.map((item, index) => {
                  return (
                    <div key={index} className="cart-item">
                      <div className='jm-flex-item'>
                        {item.productName}
                        <div>
                          <AttrString product={item} />
                        </div>
                      </div>
                      <div>
                        <NumStepper
                          items={items}
                          onAdd={onAdd}
                          onRemove={(productId, value) => {
                            onRemove(productId, value, item)
                            if (value === 1) {
                              items.length === 1 && setIsExpanded(false)
                            }

                          }}
                          curProduct={item}
                        />
                      </div>
                      <div style={{ width: '20%' }}>
                        <div className='jm-price' style={{ padding: '0 10px', textAlign: 'right', wordWrap: 'break-word' }}>
                          <PriceText product={item} from='cart' />
                          <ProductOriPrice item={item} withQuantity />
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
              <div className="cart-footer">
                <b>
                  {intl.get('total').d('合计')}:
                  <span className='jm-price'><CurrencySymbol currency={currencyCode} />{formatNumber(totalPrice)}</span>
                </b>
                <Button
                  size='small'
                  className="checkout-button"
                  loading={loading}
                  onClick={() => previewProducts()}>
                  {intl.get('ok').d('确定')}
                  ({totalQuantity})
                </Button>
              </div>
            </div>
          </div>

        )}
      </Popup>
    </div>
  );
};

export default ShoppingCart;
